// extracted by mini-css-extract-plugin
export var notificationHost = "_mo-0";